import request from "@/utils/request";

// 获取辅助信息
export const getSecondaryInfo = (params: any): Promise<any> => request({
  method: 'get',
  url: `/expose/secondary`,
  params: {
    type: params.type,
    encrypted: encodeURIComponent(params.encrypted)
  }
});

// 提交法人辅助信息
export const putSecondaryInfo = (data: any): Promise<any> => request({
  method: 'post',
  url: `/expose/secondary`,
  data
});

// 获取百度token
export const getAccessToken = (): Promise<any> => request({
  method: 'get',
  url: `baidubce/oauth/2.0/token`,
  params: {
    grant_type: 'client_credentials',
    client_id: 'ldjIBjIGFhDoT5nkJd0wACxb',
    client_secret: 'AvVliXVU0gJbYktDd6ouRSvVdUFZQzlx'
  },
  headers: {
    "content-type": "application/x-www-form-urlencoded"
  },
});

// 验证token
export const verifyToken = (access_token: string): Promise<any> => {
  return request({
    method: 'post',
    url: `baidubce/rpc/2.0/brain/solution/faceprint/verifyToken/generate`,
    params: {
      access_token
    },
    data: {
      plan_id: '20183'
    }
  });
}

// 获取人脸信息
export const getFaceInfo = (access_token: string, verify_token: string): Promise<any> => {
  return request({
    method: 'post',
    url: `baidubce/rpc/2.0/brain/solution/faceprint/result/simple`,
    params: {
      access_token
    },
    data: {
      verify_token
    },
    headers: {
      'Content-Type': 'application/json'
    }
  });
}